package com.example.mystybag.common.model

import com.example.mystybag.core.model.LinkModel

data class InternetTroubleshootingUIState(
    var issueText: List<LinkModel> = listOf()
)
